import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

// Tablo/kart içinde başka bir kaydın sayfasına giden isim bağlantısı.
// Tıklama satır seçimini veya satır çift tıklamasını tetiklemesin diye olay yukarı taşınmaz.
export default function EntityLink({ to, children, className }: { to?: string | null; children?: string | null; className?: string }) {
  const text = children || '—';
  if (!to || !children) return <span className={cn('min-w-0 truncate', className)}>{text}</span>;
  return (
    <Link
      to={to}
      title={text}
      onClick={(event) => event.stopPropagation()}
      onDoubleClick={(event) => event.stopPropagation()}
      className={cn('min-w-0 truncate text-blue-600 hover:text-blue-800 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500', className)}
    >
      {text}
    </Link>
  );
}
